<template>
  <div class="hls-player-wrapper" :class="{'full-width': fullWidth}">
    <div class="video-aspect">
      <video class="hls-video" ref="videoPlayer" controls disablePictureInPicture controlsList="nodownload" oncontextmenu="return false"/>
    </div>
    <div class="loader-block loader-block2" v-if="isLoading">
      <div class="loading">
        <div class="effect-1 effects"></div>
        <div class="effect-2 effects"></div>
        <div class="effect-3 effects"></div>
      </div>
    </div>
  </div>
</template>
<script>

import Hls from 'hls.js'
export default {
  name: 'HLSPlayer',
  props: {
    isHls: {
      type: Boolean,
      default: true,
    },
    hlsUrl: String,
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  components: { },
  data () {
    return {
      videoPlayer: null,
      isLoading: true
    }
  },
  mounted() {
  },
  methods:{
    initializePlayer() {
      this.videoPlayer = this.$refs.videoPlayer;

      if (!this.isHls) {
        this.videoPlayer.src = this.hlsUrl;
        this.isLoading = false
      } else {
        if (Hls.isSupported()) {
          const hls = new Hls();
          hls.loadSource(this.hlsUrl);
          hls.attachMedia(this.videoPlayer);
          this.isLoading = false
        } else if (this.videoPlayer.canPlayType('application/vnd.apple.mpegurl')) {
          this.videoPlayer.src = this.hlsUrl;
          this.isLoading = false
        }
      }
    },
  },
  watch: {
    hlsUrl(next, prev) {
      if (next && next !== prev) {
        this.initializePlayer();
      }
    }
  },
  beforeDestroy() {
    if (this.videoPlayer) {
      this.videoPlayer.pause();
      this.videoPlayer.removeAttribute('src');
      this.videoPlayer.load();
    }
  },
};
</script>

<style scoped lang="scss">
  .hls-player-wrapper {
    width: 700px;
    max-width: calc(90vmin - 100px);
    margin: 10px auto;
    position: relative;
    .video-aspect {
      padding-top: 56.25%;
      position: relative;
      .hls-video {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
        z-index: 12;
      }
    }
    .loader-block {
      left: 0;
      top: 0;
      background: rgba(255, 255, 255, 0.1);
    }
    &.full-width {
      width: 1000px;
    }
  }
</style>
